export const URL_CONFIG = {
  'home.mi.com': {
    collect: '/doc/collect.html?from=summary',
    privacy: '/doc/user-terms.html?type=userPrivacy',
    share: '/doc/common/mijia-data-share-explain.html'
  },
  'g.home.mi.com': {
    collect: '/views/collect.html?from=summary',
    privacy: '/views/user-terms.html?type=userPrivacy',
    share: '/views/common/mijia-data-share-explain.html'
  },
  'pv-g.home.mi.com': {
    collect: '/views/collect.html?from=summary',
    privacy: '/views/user-terms.html?type=userPrivacy',
    share: '/views/common/mijia-data-share-explain.html'
  }
}

export const LANGUAGE_MAP = {
  zh_cn: {
    "mi_home": "米家",
    "version": "版本：",
    "title": "隐私说明",
    "data_collection": "数据收集",
    "view_details": "查看详情",
    "view_full_version": "开发者“北京小米移动软件有限公司”已表明该应用将会收集以下数据。您可参阅 <a class='link' href='%1$s'>《米家隐私政策》</a> 了解详细信息。",
    "related_data": "与您关联的数据",
    "collect_data": "开发者将收集以下数据，且与您的身份关联",
    "basic_info": "个人基本信息",
    "identifier": "标识符",
    "content_data": "用户内容数据",
    "location": "位置信息",
    "sys_info": "设备和系统信息",
    "interaction_data": "用户交互数据",
    "unrelated_data": "未与您关联的数据",
    "unrelated_collect": "开发者将收集以下数据，但不会与您的身份关联",
    "diagnostic_info": "设备诊断信息",
    "data_sharing": "数据共享",
    "share_with_follow": "为保障产品和服务的稳定运行或实现相关功能，开发者“北京小米移动软件有限公司”可能会向以下第三方公司或组织共享收集到您的数据。",
    "security": "安全保障",
    "measure": "开发者“北京小米移动软件有限公司”表明已采取一定加密和管控措施以保证其收集和处理您个人信息时的安全性。",
    "encrypt_local": "数据存储在设备本地时采用加密措施",
    "encrypt_transmit": "数据传输过程中采用加密措施",
    "encrypt_server": "数据存储在服务器中时采用加密措施",
    "access_control": "数据访问权限得到管控",
    "rights": "您的权利",
    "privacy_desc": "应用数据属于用户的个人隐私，小米应用商店坚决维护用户的隐私权益，若在使用过程中发现开发者未提供以下能力，可向小米应用商店反馈。",
    "cancel_account": "支持您注销账号",
    "close_recommend": "支持您关闭个性化推荐",
    "gaode": "高德软件有限公司",
    "tencent": "深圳市腾讯计算机系统有限公司",
    "microdream": "北京微梦创科网络技术有限公司",
    "huawei": "华为软件技术有限公司",
    "oppo": "广东欢太科技有限公司",
    "alipay": "支付宝（中国）网络技术有限公司",
    "usage_purpose": "使用目的",
    "usage_scenario": "使用场景",
    "info_collection_list": "个人信息收集清单",
    "collection_status": "收集情况",
    "collected": "已收集",
    "collection_content": "收集内容",
    "not_supported": "暂未支持",
    "recent_7_days": "近 7 天",
    "recent_30_days": "近 30 天",
    "recent_one_year": "近一年",
    "basic_user_info": "用户基本信息",
    "phone_number": "手机号码",
    "email_address": "邮箱",
    "feedback_and_invoice": "用户反馈、米家众测活动、云存储会员服务相关发票开具",
    "feedback_test_invoice": "在用户提交反馈、参加众测活动、开具云存储会员服务相关发票时",
    "feedback_and_service_invoice": "用户反馈、云存储会员服务相关发票开具",
    "feedback_and_invoice_scenario": "在用户提交反馈、开具云存储会员服务相关发票时",
    "user_identity_auth": "用户网络身份标识和鉴权信息",
    "sport_health_data": "运动健康数据",
    "avatar_info": "头像信息",
    "xiaomi_account_info": "小米账号",
    "nickname_info": "昵称",
    "profile_display": "个人资料展示，来自小米账号",
    "my_page_display": "“我的”页面展示时",
    "xiaomi_services": "个人资料展示、小米服务功能",
    "my_page_xiaomi_services": "“我的”页面展示、在米家应用中使用小米服务功能时",
    "page_family_name_display": "“我的”页面展示、家庭名称展示时",
    "service_content_data": "用户服务内容和资料数据",
    "video_recording": "视频录像",
    "smart_scene_rule": "智能场景规则设置",
    "user_feedback_info": "用户反馈信息",
    "beta_test_info": "内测活动信息",
    "xiaomi_service_usage": "小米服务信息",
    "user_transaction": "用户交易信息",
    "precise_location": "精确位置信息",
    "home_location": "家庭位置信息",
    "shipping_address": "邮寄地址",
    "smart_scene_recommendation": "智能场景推荐",
    "security_device_recording": "安防设备录制视频",
    "motion_detection_recording": "安防设备识别到有人移动时自动录制视频",
    "smart_device_linkage": "智能场景（智能设备联动）",
    "smart_linkage_condition": "实现特定条件下的智能设备间联动功能时",
    "user_feedback": "用户反馈",
    "feedback_submission": "用户点击反馈页面并提交反馈时，以便联系用户进行解决",
    "beta_activity": "内测活动",
    "beta_test_participation": "用户参加米家内测活动时",
    "xiaomi_function_usage": "小米服务功能",
    "check_service_progress": "使用小米服务功能对小米账号绑定设备使用申请售后、查询服务进度、查询真伪/保修期等服务时",
    "camera_cloud_storage": "摄像机云存功能",
    "cloud_member_collection": "开通云存储会员服务后，米家收集会员信息时",
    "beta_test_address_entry": "用户参与内测活动并填写邮寄地址时",
    "smart_scene_suggestion": "推荐智能场景",
    "scene_recommend_view": "用户查看场景模块的推荐选项时",
    "user_device_info": "用户设备信息",
    "device_identifier": "硬件设备标识",
    "mobile_model": "设备型号",
    "system_info": "系统版本、语言及地区",
    "app_version": "应用程序版本",
    "screen_info": "设备屏幕尺寸及分辨率",
    "hardware_info": "CPU 及显示设备相关信息",
    "device_id": "设备 ID",
    "device_name": "设备名称",
    "room_info": "房间信息",
    "home_info": "家庭相关信息",
    "device_version": "设备版本号",
    "wifi_info": "WLAN 信息",
    "mac_address": "设备 MAC 地址",
    "bt_mac_address": "设备蓝牙 MAC 地址",
    "function_adaptation": "功能适配",
    "device_discovery": "提供智能设备快连及连接、发现附近设备和设备管理的功能时",
    "function_and_version": "功能适配、应用和固件升级",
    "app_upgrade": "提供智能设备快连及连接、发现附近设备、设备管理和米家应用升级功能时",
    "language_adaptation": "功能及语言适配",
    "experience_adaptation": "使用米家时的功能体验适配",
    "mijia_func_experience_upgrading": "使用米家时的功能体验适配、使用米家应用升级服务时",
    "function_and_experience_adaptation": "功能及体验适配",
    "smart_device_connection_and_share": "实现智能设备连接、智能设备共享和智能场景功能",
    "device_conn_share_smart_scene": "设备连接、分享及使用智能场景功能时",
    "device_sharing": "智能设备共享、小米服务或智能场景功能",
    "after_sales_service": "设备分享、使用智能场景功能及对绑定设备申请售后等小米服务时",
    "home_management": "构建智能设备的家庭管理",
    "device_operation": "使用智能设备操作时，提供快速定位房间等便捷体验",
    "show_home_info": "展示家庭信息、家庭管理、共享设备时",
    "version_update": "应用和固件升级",
    "firmware_upgrade": "用于提供智能设备的固件升级功能",
    "smart_device_connection": "智能设备连接",
    "wifi_connection": "通过 WLAN 或者蓝牙连接智能设备时",
    "wifi_zigbee_connection": "通过 WLAN 、Zig-bee 方式连接智能设备时",
    "bluetooth_connection": "通过蓝牙连接智能设备时",
    "user_face_info": "用户人脸信息",
    "face_info": "人脸信息",
    "face_recgonation": "人脸识别管理功能",
    "turn_on_face": "在用户开启人脸识别功能时",
    "not_collected": "未收集",
    "to_face_info_page": "前往\"人脸识别管理\"查看",
    "to_user_info_page": "前往\"小米账号\"查看"
  },
  zh_tw: {
    "mi_home": "米家",
    "version": "版本：",
    "title": "隱私說明",
    "data_collection": "資料收集",
    "view_details": "查看詳情",
    "view_full_version": "開發者“北京小米行動軟體有限公司”以表明該應用程式將會收集以下資料。您可參閱 <a class='link' href='%1$s'>《米家隱私政策》</a> 了解詳細資訊。",
    "related_data": "與您相關的資料",
    "collect_data": "開發者將會收集以下資料，且與您的身份有關",
    "basic_info": "個人基本資訊",
    "identifier": "識別碼",
    "content_data": "用戶內容資料",
    "location": "位置資訊",
    "sys_info": "裝置和系統資訊",
    "interaction_data": "用户交互資料",
    "unrelated_data": "非與您相關的資料",
    "unrelated_collect": "開發者將收集以下資料，但不會與您的身份有關",
    "diagnostic_info": "裝置診斷資訊",
    "data_sharing": "資料共享",
    "share_with_follow": "為保障產品和服務的穩定運行或實現相關功能，開發者“北京小米行動軟體有限公司”可能會向以下第三方公司或組織共享收集到您的資料。",
    "security": "安全保障",
    "measure": "開發者“北京小米行動軟體有限公司”表明已採取一定加密和管控措施以確保其收集和處理您個人資訊時的安全性。",
    "encrypt_local": "儲存空間在裝置本機時採用加密措施",
    "encrypt_transmit": "資料傳輸過程中採用加密措施",
    "encrypt_server": "資料儲存空間在伺服器中時採用加密措施",
    "access_control": "資料瀏覽權限得到管控",
    "rights": "您的權利",
    "privacy_desc": "應用程式資料屬於用戶的個人隱私，小米應用商店嚴正維護使用者的隱私權益，若在使用過程中發現開發者未提供以下能力，可向小米應用商店反饋。",
    "cancel_account": "支援您註銷帳號",
    "close_recommend": "支援您關閉個人化推薦",
    "gaode": "高德軟體有限公司",
    "tencent": "深圳市騰訊電腦系統有限公司",
    "microdream": "北京微夢創科網路技術有限公司",
    "huawei": "華為軟體技術有限公司",
    "oppo": "廣東歡太科技有限公司",
    "alipay": "支付寶（中國）網路技術有限公司",
    "usage_purpose": "使用目的",
    "usage_scenario": "使用場景",
    "info_collection_list": "個人資訊收集清單",
    "collection_status": "收集情況",
    "collected": "已收集",
    "not_collected": "未收集",
    "collection_content": "收集內容",
    "not_supported": "尚未支援",
    "to_face_info_page": "前往\"人臉辨識管理\"查看",
    "to_user_info_page": "前往\"小米帳號\"查看",
    "recent_7_days": "近 7 天",
    "recent_30_days": "近 30 天",
    "recent_one_year": "近一年",
    "basic_user_info": "使用者基本資訊",
    "phone_number": "手機號碼",
    "email_address": "電子信箱",
    "feedback_and_invoice": "使用者回饋、米家群測活動、雲端儲存會員服務相關發票開立",
    "feedback_test_invoice": "當使用者提交反饋、參加群測活動、開立雲端儲存會員服務相關發票時",
    "feedback_and_service_invoice": "使用者回歸、雲端儲存空間會員服務相關發票開立",
    "feedback_and_invoice_scenario": "當使用者提交回饋、開立雲端儲存會員服務相關發票時",
    "user_identity_auth": "使用者網路身分識別識別及鑑權訊息",
    "sport_health_data": "運動健康資料",
    "avatar_info": "頭貼資訊",
    "xiaomi_account_info": "小米帳號",
    "nickname_info": "暱稱",
    "profile_display": "個人資料顯示，來自小米帳號",
    "my_page_display": "“我的”頁面展示時",
    "xiaomi_services": "個人資料展示、小米服務功能",
    "my_page_xiaomi_services": "“我的”頁面展示、在米家應用程式中使用小米服務功能時",
    "page_family_name_display": "“我的”頁面展示、家庭名稱展示時",
    "service_content_data": "使用者服務內容和資料數據",
    "video_recording": "影片錄影",
    "smart_scene_rule": "智慧場景規則設定",
    "user_feedback_info": "使用者回饋資訊",
    "beta_test_info": "內測活動資訊",
    "xiaomi_service_usage": "小米服務資訊",
    "user_transaction": "使用者交易資訊",
    "precise_location": "精確位置資訊",
    "home_location": "家庭位置資訊",
    "shipping_address": "郵寄地址",
    "smart_scene_recommendation": "智慧場景推薦",
    "security_device_recording": "安防裝置錄製影片",
    "motion_detection_recording": "安防裝置辨識到有人移動時自動錄製影片",
    "smart_device_linkage": "智慧場景（智慧型裝置連動）",
    "smart_linkage_condition": "實現特定條件下的智慧型裝置間連動功能時",
    "user_feedback": "使用者回饋",
    "feedback_submission": "使用者點選回饋頁面並並提交回饋時，以便聯絡使用者以解決",
    "beta_activity": "內測活動",
    "beta_test_participation": "使用者參加米家內測活動時",
    "xiaomi_function_usage": "小米服務功能",
    "check_service_progress": "使用小米服務功能對小米帳號綁定設備使用申請售後、查詢服務進度、查詢真偽/保固期等服務時",
    "camera_cloud_storage": "攝影機雲端儲存功能",
    "cloud_member_collection": "開通雲端儲存會員服務後，米家收集會員資料時",
    "beta_test_address_entry": "用戶參與內測活動並填入郵寄地址時",
    "smart_scene_suggestion": "推薦智慧場景",
    "scene_recommend_view": "用戶查看場景模組的推薦選項時",
    "user_device_info": "使用者裝置資訊",
    "device_identifier": "手機硬體裝置辨識",
    "mobile_model": "手機型號",
    "system_info": "系統版本、語言及地區",
    "app_version": "應用程式版本",
    "screen_info": "手機螢幕尺寸及解析度",
    "hardware_info": "CPU 及顯示裝置相關資訊",
    "device_id": "裝置 ID",
    "device_name": "裝置名稱",
    "room_info": "房間資訊",
    "home_info": "家庭相關資訊",
    "device_version": "裝置版本號",
    "wifi_info": "WLAN資訊",
    "mac_address": "裝置MAC 位址",
    "bt_mac_address": "裝置藍牙MAC 位址",
    "function_adaptation": "功能適配",
    "device_discovery": "提供智慧型設備快連及連接、發現附近設備及設備管理的功能時",
    "function_and_version": "功能適配、應用程式和韌體升級",
    "app_upgrade": "提供智慧型設備快連及連接、發現附近設備、設備管理及米家應用升級功能時",
    "language_adaptation": "功能及語言適配",
    "experience_adaptation": "使用米家時的功能體驗適配",
    "mijia_func_experience_upgrading": "使用米家時的功能體驗適配、使用米家應用程式升級服務時",
    "function_and_experience_adaptation": "功能及體驗適配",
    "smart_device_connection_and_share": "實現智慧型設備連接、智慧型設備共享和智慧場景功能",
    "device_conn_share_smart_scene": "設備連接、分享及使用智慧場景功能時",
    "device_sharing": "智慧型設備共享、小米服務或智慧場景功能",
    "after_sales_service": "設備分享、使用智慧場景功能及對綁定設備申請售後等小米服務時",
    "home_management": "建構智慧型裝置的家庭管理",
    "device_operation": "使用智慧型裝置操作時，提供快速定位房間等便利體驗",
    "show_home_info": "展示家庭資訊、家庭管理、分享設備時",
    "version_update": "應用程式和韌體升級",
    "firmware_upgrade": "用於提供智慧型裝置的韌體升級功能",
    "smart_device_connection": "智慧型裝置連接",
    "wifi_connection": "過 WLAN 或藍牙連接智慧型裝置時",
    "wifi_zigbee_connection": "透過 WLAN 、Zig-bee 方式連接智慧型裝置時",
    "bluetooth_connection": "透過藍牙連接智慧型裝置時",
    "user_face_info": "使用者人臉資訊",
    "face_info": "人臉資訊",
    "face_recgonation": "人臉辨識管理功能",
    "turn_on_face": "在使用者開啟人臉辨識功能時"
  },
  en: {
    "mi_home": "Xiaomi Home",
    "version": "Version: ",
    "title": "Privacy statement",
    "data_collection": "Data collection",
    "view_details": "View details",
    "view_full_version": "The developer of this app, Beijing Xiaomi Mobile Software Co., Ltd., will collect the following data when you use this app. You can refer to the <a class='link' href='%1$s'>Xiaomi Home Privacy Policy</a> for more information.",
    "related_data": "Data linked to you",
    "collect_data": "The following data will be collected by the developer and linked to your identity:",
    "basic_info": "Basic personal info",
    "identifier": "Identifier",
    "content_data": "User content data",
    "location": "Location",
    "sys_info": "Device and system info",
    "interaction_data": "User interaction data",
    "unrelated_data": "Data not linked to you",
    "unrelated_collect": "The following data will be collected by the developer, but won't be linked to your identity:",
    "diagnostic_info": "Device diagnostic info",
    "data_sharing": "Data sharing",
    "share_with_follow": "In order to ensure the stable operation of products and services or provide related features, Beijing Xiaomi Mobile Software Co., Ltd. may share your collected data with the following third-party companies or organizations.",
    "security": "Security safeguards",
    "measure": "The developer of this app, Beijing Xiaomi Mobile Software Co., Ltd., takes certain encryption and control measures to ensure the security of its collection and processing of your personal information.",
    "encrypt_local": "Data is encrypted when stored on the device",
    "encrypt_transmit": "Data is encrypted during transfer",
    "encrypt_server": "Data is encrypted when stored on the server",
    "access_control": "Control of data access rights",
    "rights": "Your rights",
    "privacy_desc": "App data is related to a user's personal information. GetApps firmly safeguards our users' privacy rights and interests. If you find that the developer doesn't provide the following app capabilities, please send feedback to GetApps.",
    "cancel_account": "Allow users to cancel services or delete an account",
    "close_recommend": "Allow users to turn off personalized recommendations",
    "gaode": "AutoNavi Software Co., Ltd.",
    "tencent": "Shenzhen Tencent Computer System Co., Ltd",
    "microdream": "Beijing Weimeng Chuangke Network Technology Co., Ltd.",
    "huawei": "Huawei Software Technologies Co., Ltd",
    "oppo": "Guangdong HeyTap Technology Co., Ltd",
    "alipay": "Alipay (China) Network Technology Co., Ltd.",
    "usage_purpose": "Purpose of use",
    "usage_scenario": "Usage scenario",
    "info_collection_list": "Collected personal information",
    "collection_status": "Collection status",
    "collected": "Collected",
    "not_collected": "Not collected",
    "collection_content": "Collected data",
    "not_supported": "Not supported",
    "to_face_info_page": "View facial recognition-related data",
    "to_user_info_page": "View in Xiaomi Account",
    "recent_7_days": "Past 7 days",
    "recent_30_days": "Past 30 days",
    "recent_one_year": "Past year",
    "basic_user_info": "Basic user info",
    "phone_number": "Phone number",
    "email_address": "Email",
    "feedback_and_invoice": "User feedback, Xiaomi Home crowd testing, invoices for cloud storage membership services",
    "feedback_test_invoice": "When users submit feedback, take part in crowd testing, and for invoices for cloud storage membership services",
    "feedback_and_service_invoice": "User feedback, invoices for cloud storage membership services",
    "feedback_and_invoice_scenario": "When users submit feedback and for invoices for cloud storage membership services",
    "user_identity_auth": "Network identification and authentication",
    "sport_health_data": "Mi Fitness Data",
    "avatar_info": "Profile photo",
    "xiaomi_account_info": "Xiaomi Account",
    "nickname_info": "Nickname",
    "profile_display": "Profile information from Xiaomi Account",
    "my_page_display": "Displaying the \"Profile\" page",
    "xiaomi_services": "Profile information and Xiaomi services",
    "my_page_xiaomi_services": "Displaying the \"Profile\" page, using Xiaomi services in Xiaomi Home",
    "page_family_name_display": "Displaying the \"Profile\" page and home name",
    "service_content_data": "Service content and data",
    "video_recording": "Videos",
    "smart_scene_rule": "Scene rules settings",
    "user_feedback_info": "User feedback",
    "beta_test_info": "Beta testing information",
    "xiaomi_service_usage": "Xiaomi services information",
    "user_transaction": "Transaction information",
    "precise_location": "Precise location data",
    "home_location": "Home location",
    "shipping_address": "Shipping address",
    "smart_scene_recommendation": "Smart scene recommendations",
    "security_device_recording": "Security camera recordings",
    "motion_detection_recording": "Security equipment automatically records video when detecting human movement",
    "smart_device_linkage": "Smart scenes (smart device connections)",
    "smart_linkage_condition": "Linking smart devices under specific conditions",
    "user_feedback": "User feedback",
    "feedback_submission": "When users submit feedback, for contacting the user for issue resolution",
    "beta_activity": "Beta activities",
    "beta_test_participation": "When users take part in Xiaomi Home beta testing",
    "xiaomi_function_usage": "Xiaomi service features",
    "check_service_progress": "When requesting after-sales repair service, checking the progress of service, and checking the authenticity or warranty period of the device associated with the Xiaomi Account",
    "camera_cloud_storage": "Camera cloud storage features",
    "cloud_member_collection": "Collecting member information once cloud storage membership services are purchased",
    "beta_test_address_entry": "Participating in beta testing and providing a shipping address",
    "smart_scene_suggestion": "Suggesting smart scenes",
    "scene_recommend_view": "Viewing recommended options for scenes",
    "user_device_info": "Device model",
    "device_identifier": "Hardware device identifier",
    "mobile_model": "Device model",
    "system_info": "System version, language, and region",
    "app_version": "App version",
    "screen_info": "Device screen size and resolution",
    "hardware_info": "CPU and device display-related information",
    "device_id": "Device ID",
    "device_name": "Device name",
    "room_info": "Room information",
    "home_info": "Home-related information",
    "device_version": "Device version",
    "wifi_info": "WLAN information",
    "mac_address": "Device MAC address",
    "bt_mac_address": "Bluetooth MAC address",
    "function_adaptation": "Feature adaptation",
    "device_discovery": "Providing various features, including pairing with and connecting to smart devices, discovering nearby devices, and device management",
    "function_and_version": "Feature adapdation, app and firmware updates",
    "app_upgrade": "Providing smart device pairing and connectivity, discovering nearby devices, managing devices, and updating Xiaomi Home",
    "language_adaptation": "Feature and language adaptation",
    "experience_adaptation": "Feature experience adaptation when using Xiaomi Home",
    "mijia_func_experience_upgrading": "Feature experience adaptation and updating Xiaomi Home",
    "function_and_experience_adaptation": "Feature and experience adaptation",
    "smart_device_connection_and_share": "Connecting and sharing smart devices, executing smart scenes",
    "device_conn_share_smart_scene": "Connecting and sharing devices and executing smart scenes",
    "device_sharing": "Smart device sharing, Xiaomi services, and smart scenes",
    "after_sales_service": "Sharing devices, executing smart scenes, and requesting after-sales repair services for smart devices",
    "home_management": "Managing homes and smart devices",
    "device_operation": "Provide features that facilitate use of smart devices, such as locating rooms",
    "show_home_info": "Displaying home information, managing homes, and sharing devices",
    "version_update": "App and firmware updates",
    "firmware_upgrade": "Providing firmware updates for smart devices",
    "smart_device_connection": "Smart device connections",
    "wifi_connection": "Connecting smart devices via WLAN or Bluetooth",
    "wifi_zigbee_connection": "Connecting a smart device via Wi-Fi or Zig-bee",
    "bluetooth_connection": "Connecting smart devices via Bluetooth",
    "user_face_info": "Face information",
    "face_info": "Face information",
    "face_recgonation": "Managing facial recognition features",
    "turn_on_face": "When the user turns on facial recognition features"
  },
  bo_cn: {
    "mi_home": "སྨི་ཚང་།",
    "version": "པར་གཞི།",
    "title": "གསང་དོན་གྱི་གསལ་བཤད།",
    "data_collection": "གཞི་གྲངས་ཀྱི་འཚོལ་བསྡུ།",
    "view_details": "ཞིབ་ཕྲའི་སྐོར་ལ་གཟིགས་ཞིབ།",
    "view_full_version": "གསར་སྤེལ་བྱེད་མཁན\"པེ་ཅིན་གྱི་ཞའོ་སྨིའི་སྒུལ་བདེའི་མཉེན་ཆས་ཚད་ཡོད་ཀུང་སི་\"ཡིས་ཉེར་སྤྱོད་དེ་གཤམ་གསལ་གྱི་གྲངས་གཞི་འཚོལ་སྡུད་བྱེད་ངེས་ཡིན་པ་མཚོན་ཡོད།ཁྱེད་རང་གིས་<a className='link' href='%1$s'>སྟེང་དུ་སྨི་ཚང་གསང་དོན་སྲིད་ཇུས།</a>དཔྱད་ཀློག་བྱེད་ནས་ཞིབ་ཕྲའི་ཆ་འཕྲིན་རྒྱུས་རྟོགས་བྱ་ཆོག",
    "related_data": "ཁྱེད་རང་དང་འབྲེལ་བ་ཡོད་པའི་གཞི་གྲངས།",
    "collect_data": "གསར་སྤེལ་བྱེད་མཁན་གྱིས་གཤམ་གྱི་གྲངས་གཞི་འཚོལ་སྡུད་བྱ་རྒྱུ་ཡིན་ལ་ཁྱེད་ཀྱི་ཐོབ་ཐང་དང་འབྲེལ་བ་ཡོད།",
    "basic_info": "མི་སྒེར་གྱི་གཞི་རྩའི་ཆ་འཕྲིན།",
    "identifier": "མཚོན་རྟགས།",
    "content_data": "སྤྱོད་མཁན་གྱི་ནང་དོན་གཞི་གྲངས།",
    "location": "གནས་ཡུལ་ཆ་འཕྲིན།",
    "sys_info": "སྒྲིག་ཆས་དང་མ་ལག་གི་ཆ་འཕྲིན།",
    "interaction_data": "སྤྱོད་མཁན་གྱི་ནང་དོན་གཞི་གྲངས་བརྗེ་རེས།",
    "unrelated_data": "ཁྱེད་རང་དང་འབྲེལ་མེད་པའི་གཞི་གྲངས།",
    "unrelated_collect": "གསར་སྤེལ་བྱེད་མཁན་གྱིས་གཤམ་གྱི་གྲངས་གཞི་འཚོལ་སྡུད་བྱ་རྒྱུ་སྟེ་ཁྱེད་ཀྱི་ཐོབ་ཐང་དང་འབྲེལ་བ་མེད།",
    "diagnostic_info": "སྒྲིག་ཆས་ལ་བརྟག་དཔྱད་བྱེད་པའི་ཆ་འཕྲིན།",
    "data_sharing": "གཞི་གྲངས་མཉམ་སྤྱོད།",
    "share_with_follow": "ཐོན་རྫས་དང་ཞབས་ཞུ་བརྟན་པོའི་ངང་འཁོར་སྐྱོད་བྱེད་པའམ་ཡང་ན་འབྲེལ་ཡོད་ཀྱི་ནུས་པ་མངོན་འགྱུར་བྱེད་ཆེད། གསར་སྤེལ་བྱེད་མཁན་\"པེ་ཅིན་ཁྲེ་སྒུལ་བདེ་མཉེན་ཆས་ཚད་ཡོད་ཀུང་སི\"ཡིས་གཤམ་གསལ་ཕྱོགས་གསུམ་པའི་ཀུང་སིའམ་རྩ་འཛུགས་ལ་ཁྱེད་རང་གི་གཞི་གྲངས་མཉམ་སྤྱོད་དང་བསྡུ་རུབ་བྱེད་སྲིད།",
    "security": "བདེ་འཇགས་འགན་སྲུང་།",
    "measure": "གསར་སྤེལ་བྱེད་མཁན་\"པེ་ཅིན་ཞའོ་སྨིའི་སྒུལ་བདེའི་མཉེན་ཆས་ཚད་ཡོད་ཀུང་སི་\"ཡིས་གསང་སྣོན་དང་དོ་དམ་ཚོད་འཛིན་གྱི་བྱེད་ཐབས་ངེས་ཅན་སྤྱད་དེ་རང་ཉིད་ཀྱི་སྒེར་གྱི་ཆ་འཕྲིན་འཚོལ་སྡུད་དང་ཐག་གཅོད་བྱེད་སྐབས་ཀྱི་བདེ་འཇགས་རང་བཞིན་གསལ་པོར་མཚོན་ཡོད།",
    "encrypt_local": "གཞི་གྲངས་གསོག་ཉར་སྒྲིག་ཆས་ས་གནས་དེ་གའི་དུས་སུ་གསང་གྲངས་སྣོན་པའི་བྱེད་ཐབས་སྤྱོད་དགོས།",
    "encrypt_transmit": "གཞི་གྲངས་བརྒྱུད་སྐྱེལ་བྱེད་པའི་བརྒྱུད་རིམ་ཁྲོད་གསང་སྣོན་གྱི་བྱེད་ཐབས་སྤྱོད་དགོས།",
    "encrypt_server": "གཞི་གྲངས་ནི་ཞབས་ཞུའི་ཡོ་བྱད་ཁྲོད་གསོག་ཉར་བྱེད་སྐབས་གསང་སྣོན་ཀྱི་བྱེད་ཐབས་སྤྱོད་དགོས།",
    "access_control": "གཞི་གྲངས་འཚམས་འདྲིའི་དབང་ཚད་ལ་དོ་དམ་ཚོད་འཛིན་ཐེབས་ཡོད།",
    "rights": "ཁྱེད་ཀྱི་ཁེ་དབང་།",
    "privacy_desc": "ཉེར་སྤྱོད་གཞི་གྲངས་ནི་བེད་སྤྱོད་མཁན་སྒེར་གྱི་གསང་དོན་ཡིན་ལ།ཞའོ་སྨི་ཉེར་སྤྱོད་ཚོང་ཁང་གིས་སྤྱོད་མཁན་གྱི་གསང་བའི་ཁེ་དབང་སྲུང་སྐྱོང་མཐའ་གཅིག་ཏུ་བྱེད་རྒྱུ་ཡིན་ཏེ།གལ་ཏེ་བཀོལ་སྤྱོད་བྱེད་པའི་གོ་རིམ་ཁྲོད་གསར་སྤེལ་བྱེད་མཁན་གྱིས་གཤམ་གསལ་གྱི་ནུས་པ་འདོན་སྤྲོད་མ་བྱས་ན། ཞའོ་སྨི་ཉེར་སྤྱོད་ཚོང་ཁང་ལ་ལྡོག་འདྲེན་བྱས་ཆོག",
    "cancel_account": "ཁྱེད་རང་ཐོ་ཁོངས་ནས་སུབ་པར་རྒྱབ་སྐྱོར་ཡོད།",
    "close_recommend": "ཁྱེད་ཀྱིས་རང་གཤིས་ཅན་གྱི་འོས་སྦྱོར་སྒོ་རྒྱག་རྒྱུར་རྒྱབ་སྐྱོར་བྱས་ཡོད།",
    "gaode": "ཀའོ་ཏི་མཉེན་ཆས་ཚད་ཡོད་ཀུང་སི།",
    "tencent": "ཧྲེན་ཀྲེན་གྲོང་ཁྱེར་ཐེང་ཞུན་རྩིས་འཁོར་མ་ལག་ཚད་ཡོད་ཀུང་སི།",
    "microdream": "པེ་ཅིན་གྱི་ཝའེ་མེང་གསར་གཏོད་ཚན་ཁག་དྲ་རྒྱའི་ལག་རྩལ་ཚད་ཡོད་ཀུང་སི།",
    "huawei": "ཧྭ་ཝའེ་མཉེན་ཆས་ལག་རྩལ་ཚད་ཡོད་ཀུང་སི།",
    "oppo": "ཀོང་ཏུང་ཧན་ཐའེ་ཚན་རྩལ་ཚད་ཡོད་ཀུང་སི།",
    "alipay": "དངུལ་སྤྲོད་པཱའོ།(ཀྲུང་གོ)དྲ་རྒྱའི་ལག་རྩལ་ཚད་ཡོད་ཀུང་སི།",
    "usage_purpose": "བེད་སྤྱོད་བྱ་བའི་དམིགས་ཡུལ།",
    "usage_scenario": "བེད་སྤྱོད་བྱེད་ཚུལ།",
    "info_collection_list": "མི་སྒེར་གྱི་ཆ་འཕྲིན་འཚོལ་སྡུད་རྩིས་ཁྲ།",
    "collection_status": "འཚོལ་བསྡུ་གྱི་གནས་ཚུལ།",
    "collected": "འཚོལ་བསྡུ་ཚར་བ་ཡིན།",
    "not_collected": "འཚོལ་བསྡུ་བྱེད་མེད།",
    "collection_content": "འཚོལ་བསྡུའི་ནང་དོན།",
    "not_supported": "གནས་སྐབས་ལ་རྒྱབ་སྐྱོར་མེད།",
    "to_face_info_page": "ངོ་གདོང་དབྱེ་འབྱེད་དོ་དམ་ནང་འཛུལ་ནས་འཚོལ་བཤེར་བྱེད་པ།",
    "to_user_info_page": "ཞའོ་སྨིའི་རྩིང་ཐོ་ནང་འཛུལ་ནས་འཚོར་བཤེར་བྱེད་པ།",
    "recent_7_days": "ཉེ་བའི་ཉིན་བདུན་ནང་།",
    "recent_30_days": "ཉེ་བའི་ཉིན་སུམ་ཅུའི་ནང་།",
    "recent_one_year": "ཉེ་བའི་ལོ་གཅིག་ནང་།",
    "basic_user_info": "སྤྱོད་མཁན་གྱི་གཞི་རྩའི་ཆ་འཕྲིན།",
    "phone_number": "ཁ་པར་ཨང་གྲངས།",
    "email_address": "ཡིག་སྒམ།",
    "feedback_and_invoice": "སྤྱོད་མཁན་གྱིས་ལྡོག་འདྲེན་དང་། སྨི་ཚང་གི་མི་མང་ཚད་ལེན་བྱེད་སྒོ། སྤྲིན་གསོག་ཚོགས་མིའི་ཞབས་ཞུའི་འབྲེལ་ཡོད་འཛིན་ཤོག་བཅས་ཀྱི་ཐོག་ནས་འཛིན་ཤོག་སྤྲོད་དགོས།",
    "feedback_test_invoice": "སྤྱོད་མཁན་གྱིས་ལྡོག་འདྲེན་དང་མང་ཚོགས་ཀྱི་ཚད་ལེན་བྱེད་སྒོར་ཞུགས་པ། སྤྲིན་འཛིན་ཉར་ཚགས་ཚོགས་མིའི་ཞབས་ཞུའི་འབྲེལ་ཡོད་འཛིན་ཤོག་འདོན་སྤྲོད་བྱེད་སྐབས།",
    "feedback_and_service_invoice": "སྤྱོད་མཁན་གྱིས་ལྡོག་འདྲེན་དང་སྤྲིན་གསོག་ཚོགས་མིའི་ཞབས་ཞུའི་འབྲེལ་ཡོད་འཛིན་ཤོག་བཅས་ཀྱི་སྤྲོད་ལེན།",
    "feedback_and_invoice_scenario": "སྤྱོད་མཁན་གྱིས་ལྡོག་འདྲེན་དང་སྤྲིན་འཛིན་གསོག་ཉར་ཚོགས་མིའི་ཞབས་ཞུའི་འབྲེལ་ཡོད་འཛིན་ཤོག་སྤྲོད་སྐབས།",
    "user_identity_auth": "སྤྱོད་མཁན་གྱི་དྲ་རྒྱའི་ཐོབ་ཐང་མཚོན་རྟགས་དང་དཔྱད་གཞིའི་དབང་ཆའི་ཆ་འཕྲིན།",
    "avatar_info": "མགོ་པར་ཆ་འཕྲིན།",
    "xiaomi_account_info": "ཞའོ་མཱི་རྩིས་ཨང་།",
    "nickname_info": "གཅེས་མིང་།",
    "profile_display": "མི་སྒེར་གྱི་དཔྱད་གཞི་གསལ་སྟོན།ཞའོ་མཱི་རྩིང་ཨང་ནས་ཡོང་བ།",
    "my_page_display": "ངའི་ཤོག་ངོས་འགྲེམ་སྟོན་བྱེད་སྐབས།",
    "xiaomi_services": "མི་སྒེར་གྱི་དཔྱད་གཞི་འགྲེམས་སྟོན།ཞའོ་མཱིའི་ཞབས་ཞུ་བྱེད་ནུས།",
    "my_page_xiaomi_services": "ངའི་ཤོག་ངོས་འགྲེམ་སྟོན་བྱེད་སྐབས།ཡང་ན་སྨི་ཚང་གི་ཉེར་སྤྱོད་ཁྲོད་ཞའོ་མཱིའི་ཞབས་ཞུའི་ནུས་པ་བཀོལ་སྤྱོད་བྱེད་སྐབས།",
    "page_family_name_display": "ངའི་ཤོག་ངོས་འགྲེམ་སྟོན་བྱེད་སྐབས།ཡང་ན་ཁྱིམ་ཚང་གི་མིང་འགྲེམས་སྟོན་བྱེད་སྐབས།",
    "service_content_data": "སྤྱོད་མཁན་གྱི་ཞབས་ཞུའི་ནང་དོན་དང་དཔྱད་གཞིའི་གྲངས་གཞི།",
    "video_recording": "བརྙན་ལམ་བརྙན་ཕབ།",
    "smart_scene_rule": "རིག་ནུས་རྣམ་པའི་སྒྲིག་སྲོལ་སྒྲིག་འགོད།",
    "user_feedback_info": "སྤྱོད་མཁན་གྱི་ལྡོག་འདྲེན་ཆ་འཕྲིན།",
    "beta_test_info": "ནང་སྤྱོད་བྱ་འགུལ་གྱི་ཆ་འཕྲིན།",
    "xiaomi_service_usage": "ཞའོ་མཱིའི་ཞབས་ཞུ་ཆ་འཕྲིན།",
    "user_transaction": "སྤྱོད་མཁན་གྱི་ཉོ་ཚོང་ཆ་འཕྲིན།",
    "precise_location": "གནས་བབ་གནད་ལ་འཁེལ་བའི་ཆ་འཕྲིན།",
    "home_location": "ཁྱིམ་ཚང་གི་སྡོད་གནས་ཆ་འཕྲིན།",
    "shipping_address": "སྦྲག་སྐྱེལ་ས་གནས།",
    "smart_scene_recommendation": "རིག་ནུས་རྣམ་པ་འོས་སྦྱོར།",
    "security_device_recording": "བདེ་སྲུང་སྒྲིག་ཆས་ཀྱིས་བརྙན་རིས་ཕབ་ལེན།",
    "motion_detection_recording": "བདེ་སྲུང་སྒྲིག་ཆས་ཀྱིས་མི་འགུལ་སྐྱོད་དུས་སུ་རང་འགུལ་གྱིས་བརྙན་རིས་ཕབ་ལེན་སྲིད།",
    "smart_device_linkage": "རིག་ནུས་རྣམ་པ། (རིག་ནུས་སྒྲིག་ཆས་མཉམ་འགུལ། )",
    "smart_linkage_condition": "དམིགས་བསལ་ཆ་རྐྱེན་འོག་གི་རིག་ནུས་སྒྲིག་ཆས་བར་གྱི་མཉམ་འགུལ་ནུས་པ་མངོན་འགྱུར་བྱེད་སྐབས།",
    "user_feedback": "སྤྱོད་མཁན་གྱི་ལྡོག་འདྲེན།",
    "feedback_submission": "སྤྱོད་མཁན་གྱིས་ལྡོག་འདྲེན་ཤོག་ངོས་གནོན་ནས་བསམ་འཆར་ལྡོག་འདྲེན་བྱེད་སྐབས།སྤྱོད་མཁན་ལ་འབྲེལ་གཏུག་བྱས་ནས་ཐག་གཅོད་བྱེད་བདེ་ཡོང་བ་བྱ་དགོས།",
    "beta_activity": "ནང་སྤྱོད་བྱ་འགུལ།",
    "beta_test_participation": "སྤྱོད་མཁན་སྨི་ཚང་གི་ནང་སྤྱོད་བྱ་འགུལ་ལ་ཞུགས་སྐབས།",
    "xiaomi_function_usage": "ཞའོ་མཱིའི་ཞབས་ཞུ་བྱེད་ནུས།",
    "check_service_progress": "ཞའོ་སྨིའི་ཞབས་ཞུའི་ནུས་པ་སྤྱད་དེ་ཞའོ་སྨིའི་རྩིས་ཐོའི་ཨང་རྟགས་་ནས་བཙོང་རེ་ཞུས་རྗེས་དང་། ཞབས་ཞུའི་མྱུར་ཚད་འདྲི་རྩད། བདེན་རྫུན་འདྲི་རྩད་འདྲི་རྩད་དང་ཉམས་གསོའི་ཡུན་ཚོད་སོགས་བཀོལ་ནས་ཞབས་འདེགས་ཞུ་སྐབས།",
    "camera_cloud_storage": "བརྙན་ལེན་འཕྲུལ་ཆས་ཀྱི་སྤྲིན་གསོག་ནུས།",
    "cloud_member_collection": "སྤྲིན་གསོག་ཉར་གྱི་ཚོགས་མིར་ཞུགས་རྗེས།སྨི་ཚང་གིས་ཚོགས་མིའི་ཆ་འཕྲིན་འཚོལ་བསྡུ་སྐབས།",
    "beta_test_address_entry": "སྤྱོད་མཁན་ནང་སྤྱོད་བྱ་འགུལ་དུ་ཞུགས་ཤིང་སྦྲག་ཐོག་བསྐུར་གནས་འབྲི་སྐབས།",
    "smart_scene_suggestion": "རིག་ནུས་རྣམ་པ་འོས་སྦྱོར།",
    "scene_recommend_view": "སྤྱོད་མཁན་གྱིས་རྣམ་པའི་དཔེ་དབྱིབས་ཀྱི་འོས་སྦྱོར་གདམ་གསེས་ལ་གཟིགས་ཞིབ་གནང་སྐབས།",
    "user_device_info": "སྤྱོད་མཁན་གྱི་སྒྲིག་ཆས་ཆ་འཕྲིན།",
    "device_identifier": "ཁ་པར་གྱི་སྲ་ཆས་སྒྲིག་ཆས་མཚོན་རྟགས།",
    "mobile_model": "ཁ་པར་གྱི་བཟོ་དབྱིབས།",
    "system_info": "མ་ལག་གི་པར་གཞི།སྐད་རིགས་དང་ས་ཁུལ།",
    "app_version": "ཉེར་སྤྱོད་གོ་རིམ་གྱི་པར་གཞི།",
    "screen_info": "ལག་ཐོགས་ཁ་པར་གྱི་བརྙན་ཤེལ་ཆེ་ཆུང་དང་དབྱེ་འབྱེད་བྱེད་ཚད།",
    "hardware_info": "CPU དང་མངོན་འཆར་སྒྲིག་ཆས་ཀྱི་འབྲེལ་ཡོད་ཆ་འཕྲིན།",
    "device_id": "སྒྲིག་ཆས། ID",
    "device_name": "སྒྲིག་ཆས་མིང་།",
    "room_info": "ཁང་མིག་གི་ཆ་འཕྲིན།",
    "home_info": "ཁྱིམ་ཚང་གི་འབྲེལ་ཡོད་ཆ་འཕྲིན།",
    "device_version": "སྒྲིག་ཆས་ཀྱི་པར་གཞི་ཨང་གྲངས།",
    "wifi_info": "WLANཆ་འཕྲིན།",
    "mac_address": "སྒྲིག་ཆས།MAC ས་གནས།",
    "bt_mac_address": "སྒྲིག་ཆས་སོ་སྔོན།MAC ས་གནས།",
    "function_adaptation": "བྱེད་ནུས་འཚམ་སྒྲིག",
    "device_discovery": "རིག་ནུས་སྒྲིག་ཆས་མཁོ་འདོན་བྱས་ནས་མྱུར་དུ་སྦྲེལ་མཐུད་དང་རྒྱུན་ལྡན་སྦྲེལ་མཐུད་བྱེད་པ་འདོན་སྤྲོད།ཉེ་འགྲམ་གྱི་སྒྲིག་ཆས་དང་སྒྲིག་ཆས་དོ་དམ་གྱི་ནུས་པ་རྙེད་སྐབས།",
    "function_and_version": "བྱེད་ནུས་འཚམ་སྒྲིག ཉེར་སྤྱོད་དང་སྲ་ཆས་རིམ་སྤར།",
    "app_upgrade": "རིག་ནུས་སྒྲིག་ཆས་མཁོ་འདོན་བྱས་ནས་མྱུར་དུ་སྦྲེལ་མཐུད་དང་རྒྱུན་ལྡན་སྦྲེལ་མཐུད་བྱེད་པ་འདོན་སྤྲོད།ཉེ་འགྲམ་གྱི་སྒྲིག་ཆས་དང་སྒྲིག་ཆས་དོ་དམ།སྨི་ཚང་གི་ཉེར་སྤྱོད་རིམ་སྤར་གྱི་ནུས་པ་རྙེད་སྐབས།",
    "language_adaptation": "བྱེད་ནུས་དང་སྐད་རིགས་འཚམ་སྒྲིག",
    "experience_adaptation": "སྨི་ཚང་སྤྱོད་སྐབས་ཀྱི་བྱེད་ནུས་ཉམས་ལེན་འཚམ་སྒྲིག",
    "mijia_func_experience_upgrading": "སྨི་ཚང་སྤྱོད་སྐབས་ཀྱི་བྱེད་ནུས་ཉམས་ལེན་འཚམ་སྒྲིག སྨི་ཚང་ཉེར་སྤྱོད་རིམ་སྤར་གྱི་ཞབས་ཞུ་སྤྱོད་སྐབས།",
    "function_and_experience_adaptation": "བྱེད་ནུས་དང་ཉམས་ལེན་འཚམ་སྒྲིག",
    "smart_device_connection_and_share": "རིག་ནུས་སྒྲིག་ཆས་སྦྲེལ་མཐུད།རིག་ནུས་སྒྲིག་ཆས་མཉམ་སྤྱོད་དང་རིག་ནུས་རྣམ་པའི་བྱེད་ནུས་དངོས་འགྱུར་བྱེད་པ།",
    "device_conn_share_smart_scene": "སྒྲིག་ཆས་སྦྲེལ་མཐུད།མཉམ་སྤྱོད་དང་རིག་ནུས་རྣམ་པའི་བྱེད་ནུས་བཀོལ་སྐབས།",
    "device_sharing": "རིག་ནུས་སྒྲིག་ཆས་མཉམ་སྤྱོད།ཞའོ་མཱིའི་ཞབས་ཞུ་ཡང་ན་རིག་ནུས་རྣམ་པའི་བྱེད་ནུས།",
    "after_sales_service": "སྒྲིག་ཆས་མཉམ་སྤྱོད།རིག་ནུས་རྣམ་པའི་བྱེད་ནུས་དང་སྒྲིག་ཆས་སྦྲེལ་ནས་བཙོང་རྒྱུའི་རེ་འདུན་ཞུས་བ་སོགས་ཀྱི་ཞའོ་སྨིའི་ཞབས་ཞུ་བཀོལ་སྐབས།",
    "home_management": "རིག་ནུས་སྒྲིག་ཆས་ཀྱི་ཁྱིམ་ཚང་དོ་དམ་འཛུགས་སྐྱོང་བྱ་དགོས།",
    "device_operation": "རིག་ནུས་སྒྲིག་ཆས་བཀོལ་སྤྱོད་བྱེད་སྐབས་མགྱོགས་མྱུར་ངང་ཁང་མིག་སོགས་ས་གནས་གཏན་འཁེལ་གྱི་སྟབས་བདེའི་ཉམས་ལེན་འདོན་སྤྲོད་བྱེད་ཡོད།",
    "show_home_info": "ཁྱིམ་ཚང་གི་ཆ་འཕྲིནའགྲེམས་སྟོན།ཁྱིམ་ཚང་དོ་དམ།སྒྲིག་ཆས་མཉམ་སྤྱོད་སྐབས།",
    "version_update": "ཉེར་སྤྱོད་དང་སྲ་ཆས་རིམ་སྤར།",
    "firmware_upgrade": "རིག་ནུས་སྒྲིག་ཆས་སྲ་ཆས་ཀྱི་རིམ་སྤར་བའི་བྱེད་ནུས་འདོན་སྤྲོད་བྱེད་པར་སྤྱོད་དགོས།",
    "smart_device_connection": "རིག་ནུས་སྒྲིག་ཆས་སྦྲེལ་མཐུད།",
    "wifi_connection": "WLANཡང་ན་སོ་སྔོན་བརྒྱུད་ནས་རིག་ནུས་སྒྲིག་ཆས་སྦྲེལ་སྐབས།",
    "wifi_zigbee_connection": "WLAN、Zig-bee བྱེད་ཐབས་བརྒྱུད་ནས་རིག་ནུས་ཀྱི་སྒྲིག་ཆས་སྦྲེལ་སྐབས།",
    "bluetooth_connection": "སོ་སྔོན་བརྒྱུད་ནས་རིག་ནུས་སྒྲིག་ཆས་སྦྲེལ་སྐབས།",
    "user_face_info": "སྤྱོད་མཁན་གྱི་ངོ་གདོང་ཆ་འཕྲིན།",
    "face_info": "ངོ་གདོང་ཆ་འཕྲིན།",
    "face_recgonation": "ངོ་གདོང་དབྱེ་འབྱེད་དོ་དམ་བྱེད་ནུས།",
    "turn_on_face": "སྤྱོད་མཁན་གྱིས་ངོ་གདོང་དབྱེ་འབྱེད་བྱེད་ནུས་ཁ་ཕྱེ་སྐབས།"
  },
  ug_cn: {
    "mi_home": "مىجيا",
    "version": "نەشرى：",
    "title": "شەخسىيەت چۈشەندۈرمسى",
    "data_collection": "سانلىق مەلۇماتنى توپلاش",
    "view_details": "تەپسىلاتىنى كۆۈرۈش",
    "view_full_version": "ئاچقۇچى“بېيجىڭ شياۋمى كۆچمە يۇمشاق دېتال چەكلىك شىركىتى“مەزكۇر ئەپنىڭ تۆۋەندىكى سانلىق مەلۇماتنى يىغىدىغانلىقىنى بىلدۈردى.سىز<a class='link' href='%1$s'>«مىجيا شەخسىىي مەخپىيەتلىك سىياسىتى»</a>دىن تەپسىلىي ئۇچۇرنى ئوقۇپ پايدىلانسىڭىز بولىدۇ.",
    "related_data": "سىزگە باغلىنىشلىق سانلىق مەلۇمات",
    "collect_data": "ئاچقۇچىلار تۆۋەندىكى سانلىق مەلۇماتلارنى توپلايدۇ ھەمدە سىزنىڭ سالاھىيىتىڭىز بىلەن باغلايدۇ",
    "basic_info": "ئاساسىي شەخسىي ئۇچۇر",
    "identifier": "تونۇش بەلگىسى",
    "content_data": "ئابۇنىت مەزمۇنى سانلىق مەلۇماتى",
    "location": "ئورۇن ئۇچۇرى",
    "sys_info": "ئۈسكۈنە ۋە سېستىما ئۇچۇرى",
    "interaction_data": "ئابۇنىت ئۆزئارا مەشغۇلات قىلغان سانلىق مەلۇمات",
    "unrelated_data": "سىزگە باغلانمىغان سانلىق مەلۇمات",
    "unrelated_collect": "ئاچقۇچى تۆۋەندكى سانلىق مەلۇماتنى يىغىدۇ،لىكىن سىزنىڭ سالاھىتىڭىزگە باغلىمايدۇ",
    "diagnostic_info": "ئۈسكۈنە دىياگنوز ئۇچۇرى",
    "data_sharing": "سانلىق مەلۇماتتىن ئورتاق بەھىرلىنىش",
    "share_with_follow": "مەھسۇلات ۋە مۇلازىمەتنىڭ مۇقىم يۈرۈشۈشىگە كاپالەتلىك قىلىش ياكى ئالاقىدار ئىقتىدارلارنى ئەمەلگە ئاشۇرۇش ئۈچۈن،ئاچقۇچى“بېيجىڭ شياۋمى كۆچمە يۇمشاق دېتال چەكلىك شىركىتى“تۆۋەندىكى ئۈچىنچى تەرەپ شىركەتلىرى ياكى تەشكىلاتلار بىلەن سىزدىن توپلىىغان سانلىق مەلۇماتنى ئورتاق بەھىرلىنىشى مۇمكىن.",
    "security": "بىخەتەرلىك كاپالىتى",
    "measure": "ئاچقۇچى“بېيجىڭ شياۋمى كۆچمە يۇمشاق دېتال چەكلىك شىركىتى“بەلگىلىك شىفىرلاشتۇرۇش ۋە باشقۇرۇش، كونترول قىلىش تەدبىرى قوللىنىلىپ، سىزنىڭ شەخسىي ئۇچۇرىڭىزنى يىغىش ۋە بىر تەرەپ قىلىشتىكى بىخەتەرلىككە كاپالەتلىك قىلىدىغانلىقىنى بىلدۈرىدۇ.",
    "encrypt_local": "سانلىق مەلۇمات ئۈسكۈنىگە يەرلىك ساقلانغاندا شىفىرلاشتۇرۇش تەدبىرى قوللىنىدۇ",
    "encrypt_transmit": "سانلىق مەلۇمات يوللاپ قۇبۇل قىلغاندا شىفىرلاشتۇرۇش تەدبىرى قوللىنىدۇ",
    "encrypt_server": "سانلىق مەلۇمات مۇلازىمېتىرگە ساقلانغاندا شىفىرلاشتۇرۇش تەدبىرى قوللىنىدۇ",
    "access_control": "سانلىق مەلۇماتنى زىيارەت قىلىش ھوقۇقى كونترول قىلىندۇ",
    "rights": "سىزنىڭ ھوقۇقىڭىز",
    "privacy_desc": "ئەپ سانلىق مەلۇماتى ئابۇنىتنىڭ شەخسىي مەخپىيەتلىكىگە تەۋە، شياۋمى ئەپ دۇكىنى ئابۇنىچىنىڭ شەخسىيەت ھوقۇق-مەنپەئىتىنى قەتئىي قوغدايدۇ، ئەگەر ئىشلىتىش جەريانىدا ئاچقۇچىنىڭ تۆۋەندىكى ئىقتىدارلار بىلەن تەمىنلىمىگەنلىكىنى بايقىسا، شياۋمى ئەپ دۇكىنىغا ئىنكاس قىلسا بولىدۇ.",
    "cancel_account": "سىزنىڭ ھېساباتنى بىكار قىلىشنى قوللاش",
    "close_recommend": "سىزنىڭ خاس تەۋسىيەنى تاقاشنى قوللاش",
    "gaode": "گاۋدې يۇمشاق دېتال چەكلىك شىركىتى",
    "tencent": "شېنجېن شەھىرى تېڭشۈن كومپيۇتېر سىستېمىسى چەكلىك شىركىتى",
    "microdream": "بېيجىڭ ۋېيمېڭ چۇاڭكې تور تېخنىكا چەكلىك شىركىتى",
    "huawei": "خۇاۋېي يۇمشاق دېتال تېخنىكا چەكلىك شىركىتى",
    "oppo": "گۇاڭدۇڭ خۇەنتەي پەن ـ تېخنىكا چەكلىك شىركىتى",
    "alipay": "جىفۇباۋ(جۇڭگو)تور تېخنىكا چەكلىك شىركىتى",
    "usage_purpose": "ئىشلىتىش مەقسىتى",
    "usage_scenario": "ئىشلىتىش ئورنى",
    "info_collection_list": "شەخسىي ئۇچۇر توپلاش تىزىملىكى",
    "collection_status": "توپلاش ئەھۋالى",
    "collected": "توپلاندى",
    "not_collected": "يىغمىدى",
    "collection_content": "مەزمۇن توپلاش",
    "not_supported": "ۋاقتىنچە قوللىمىدى",
    "to_face_info_page": "”چىراي تۇنۇشنى باشقۇرۇش“قا بېرىپ تەكشۈرۈش",
    "to_user_info_page": "”شىياۋمى ھېساباتى“غا بېرىپ تەكشۈرۈش",
    "recent_7_days": "يېقىنقى7 كۈن",
    "recent_30_days": "يېقىنقى 30 كۈن",
    "recent_one_year": "يېقىنقى بىر يىل",
    "basic_user_info": "ئابۇنىتنىڭ ئاساسىي ئۇچۇرى",
    "phone_number": "يانفون نومۇرى",
    "email_address": "تورخەت ساندۇقى",
    "feedback_and_invoice": "ئابونىتلار ئىنكاسى،مىجيا كۆپچىكىل سىناش پائالىيىتى،بۇلۇت ساقلاش ئەزالار مۇلازىمىتىگە ئالاقىدار تالون كېسىش",
    "feedback_test_invoice": "ئابونىتلار ئىنكاس تاپشۇرۇپ،مىجيا كۆپچىكىل سىناش پائالىيىتى،بۇلۇت ساقلاش ئەزالار مۇلازىمىتىگە ئالاقىدار تالون كەسكەن چاغدا",
    "feedback_and_service_invoice": "ئابونىتلار ئىنكاس ،بۇلۇت ساقلاش ئەزالار مۇلازىمىتىگە ئالاقىدار تالون كېسىش",
    "feedback_and_invoice_scenario": "ئابۇنىچى ئىنكاس تاپشۇرغاندا، بۇلۇت ساقلاش ئەزالار مۇلازىمىتىگە ئالاقىدار تالون كېسىپ بەرگەندە",
    "user_identity_auth": "ئابۇنىچى تور سالاھىيەت بەلگىسى ۋە باھالاش ھوقۇقى ئۇچۇرى",
    "avatar_info": "باش سۈرىتى ئۇچۇرى",
    "xiaomi_account_info": "شياۋمى ھېساباتى",
    "nickname_info": "ئىسمى",
    "profile_display": "شەخسىي ماتېرىيالنى كۆرسىتىش،شياۋمى ھېساباتىدىن كەلگەن",
    "my_page_display": "\"مېنىڭ\"بېتى كۆرسىتىلگەندە",
    "xiaomi_services": "شەخسىي ماتېرىيالنى كۆرسىتىش،شياۋمىنىڭ مۇلازىمەت ئىقتىدارى",
    "my_page_xiaomi_services": "\"مېنىڭ\"بېتى كۆرسىتىلگەندە،مىجيا ئەپلىرىدە شياۋمى مۇلازىمەت ئىقتىدارىنى ئىشلەتكەندە",
    "page_family_name_display": "\"مېنىڭ\"بېتى كۆرسىتىلگەندە،ئائىلە نامى كۆرسىتىلگەندە",
    "service_content_data": "ئابۇنىچىلار مۇلازىمەت مەزمۇنى ۋە ماتېرىيال سانلىق مەلۇماتى",
    "video_recording": "سىنغا ئېلىش",
    "smart_scene_rule": "ئەقلىي كۆرۈنۈش قائىدىسى تەڭشىكى",
    "user_feedback_info": "ئابونىت ئىنكاس قىلغان ئۇچۇر",
    "beta_test_info": "ئىچكى سىناش پائالىيەت ئۇچۇرى",
    "xiaomi_service_usage": "شياۋمى مۇلازىمەت ئۇچۇرى",
    "user_transaction": "ئابونىت سودا ئۇچۇرى",
    "precise_location": "توغرا ئورۇن ئۇچۇرى",
    "home_location": "ئائىلە ئورنى ئۇچۇرى",
    "shipping_address": "پوچتىدىن ئەۋەتىش ئادرېسى",
    "smart_scene_recommendation": "ئەقلىي ئىقتىدارلىق كۆرۈنۈش تەۋسىيە قىلىش",
    "security_device_recording": "بىخەتەرلىك ئۈسكۈنىلىرى سىنغا ئېلىش",
    "motion_detection_recording": "بىخەتەرلىك ئۈسكۈنىسى ئادەم يۆتكەلگەننى سەزگەندە ئاپتوماتىك سىنغا ئالىدۇ",
    "smart_device_linkage": "ئەقلىي ئىقتىدارلىق كۆرۈنۈشى(ئەقلىي ئىقتىدارلىق ئۈسكۈنىلەر بىرلىشىپ ھەرىكەتلىنىش)",
    "smart_linkage_condition": "ئالاھىدە شارائىتتىكى ئەقلىي ئىقتىدارلىق ئۈسكۈنىلەر ئارا بىرلەشمە ھەرىكەت ئىقتىدارىنى ئىشقا ئاشۇرغاندا",
    "user_feedback": "ئابۇنىت ئىنكاسى",
    "feedback_submission": "ئابۇنىت ئىنكاس قايتۇرۇش بېتىنى چېكىپ ھەمدە ئىنكاس تاپشۇرغاندا،ئابۇنىت بىلەن ئالاقىلىشىپ ھەل قىلىشقا قولايلىق بولىدۇ",
    "beta_activity": "ئىچكى سىناش پائالىيىتى",
    "beta_test_participation": "ئابۇنىت مىجيانىڭ ئىچكى سىناش پائالىيىتىگە قاتناشقاندا",
    "xiaomi_function_usage": "شياۋمى مۇلازىمەت ئىقتىدارى",
    "check_service_progress": "شياۋمى مۇلازىمەت ئىقتىدارىنى ئىشلىتىپ شياۋمى ھېسابات نومۇرىغا باغلىغان ئۈسكۈنىگە سېتىشتىن كېيىنكى مۇلازىمەتنى ئىلتىماس قىلىش،مۇلازىمەت سۈرئىتىنى تەكشۈرۈش،راست يالغانلىقىنى\\رېمونت قىلىش مۇددىتىنى تەكشۈرۈش قاتارلىق مۇلازىمەتلەرنى قىلغاندا",
    "camera_cloud_storage": "كامېرا بۇلۇت ساقلاش ئىقتىدارى",
    "cloud_member_collection": "بۇلۇت ساقلىغۇچ ئەزالىق مۇلازىمىتىنى ئاچقاندىن كېيىن،مى جيا ئەزالارنىڭ ئۇچۇرىنى توپلىغاندا",
    "beta_test_address_entry": "ئابۇنىت ئىچكى سىناش پائالىيىتىگە قاتناشقان ھەمدە پوچتىدىن ئەۋەتىش ئادرېسىنى تولدۇرغاندا",
    "smart_scene_suggestion": "ئەقلىي ئىقتىدارلىق كۆرۈنۈش تەۋسىيە قىلىش",
    "scene_recommend_view": "ئابونىت كۆرۈنۈش بۆلىكىدىكى تەۋسىيە قىلىنغان تاللاشنى تەكشۈرگەندە",
    "user_device_info": "ئابونىت ئۈسكۈنە ئۇچۇرى",
    "device_identifier": "تېلفۇن قاتتىق دىتال ئۈسكۈنە بەلگىسى",
    "mobile_model": "يانفۇن تىپى",
    "system_info": "سىستېما نەشىر نۇسخىسى،تىل ۋە رايون",
    "app_version": "ئەپ نەشرى",
    "screen_info": "يانفون ئېكرانىنىڭ چوڭ-كىچىكلىكى ۋە ئېنىقلىق دەرىجىسى",
    "hardware_info": "CPU ۋە ئۈسكۈنىگە مۇناسىۋەتلىك ئۇچۇرلارنى كۆرسىتىش",
    "device_id": "ئۈسكۈنەID",
    "device_name": "ئۈسكۈنە نامى",
    "room_info": "ئۆي ئۇچۇرى",
    "home_info": "ئائىلىگە مۇناسىۋەتلىك ئۇچۇر",
    "device_version": "ئۈسكۈنە نەشر نۇمۇرى",
    "wifi_info": "WLANئۇچۇرى",
    "mac_address": "ئۈسكۈنەMAC ئادرېسى",
    "bt_mac_address": "ئۈسكۈنە كۆكچىش MAC ئادرېسى",
    "function_adaptation": "ئىقتىدار ماسلاشتۇرۇش",
    "device_discovery": "ئەقلىي ئىقتىدارلىق ئۈسكۈنىنىڭ تېز ئۇلىنىشى ۋە ئۇلىنىشى،ئەتراپتىكى ئۈسكۈنىنى بايقاش ۋە ئۈسكۈنە باشقۇرۇش ئىقتىدارىنى تەمىنلىگەندە",
    "function_and_version": "ئىقتىدارىنى ماسلاشتۇرۇش،ئەپ ۋە قۇيما دېتال نەشىر دەرىجىسىنى ئۆستۈرگەندە",
    "app_upgrade": "ئەقلىي ئىقتىدارلىق ئۈسكۈنىنىڭ تېز ئۇلىنىشى ۋە ئۇلىنىشى،ئەتراپتىكى ئۈسكۈنىنى بايقاش،ئۈسكۈنە باشقۇرۇش ۋە مىجيا ئەپ نەشىر دەرىجىسىنى يۇقىرىلىتىش ئىقتىدارىنى تەمىنلىگەندە",
    "language_adaptation": "ئىقتىدارى ۋە تىلى ماس كېلىش",
    "experience_adaptation": "مىجيانى ئىشلەتكەن چاغدىكى ئىقتىدار تەسىراتىنى ماسلاشتۇرۇش",
    "mijia_func_experience_upgrading": "مىجيانى ئىشلەتكەن چاغدىكى ئىقتىدار تەسىراتىنى ماسلاشتۇرۇش،مىجيا ئەپ نەشىر دەرىجىسىنى ئۆستۈرۈش مۇلازىمىتىنى ئىشلەتكەندە",
    "function_and_experience_adaptation": "ئىقتىدار ۋە تەسىرات ماسلاشتۇرۇش",
    "smart_device_connection_and_share": "ئەقلىي ئۈسكۈنىلەرنى ئۇلاش، ئەقلىي ئۈسكۈنىلەرنى ھەمبەھرىلەش ۋە ئەقلىي كۆرۈنۈش ئىقتىدارىنى ئىشقا ئاشۇرۇش",
    "device_conn_share_smart_scene": "ئۈسكۈنە ئۇلاش،ئەقلىي كۆرۈنۈش ئىقتىدارىنى ھەمبەھرىلىگەندە ۋە ئىشلەتكەندە",
    "device_sharing": "ئەقلىي ئۈسكۈنىلەردىن ئورتاق بەھرىلىنىش، شياۋمى مۇلازىمىتى ياكى ئەقلىي كۆرۈنۈش ئىقتىدارى",
    "after_sales_service": "ئۈسكۈنىلەرنى ھەمبەھرىلەش، ئەقلىي ئىقتىدارلىق كۆرۈنۈش ئىقتىدارىنى ئىشلىتىش ۋە باغلىغان ئۈسكۈنىلەرگە سېتىشتىن كېيىنكى مۇلازىمەتنى ئىلتىماس قىلغاندا",
    "home_management": "ئەقلىي ئۈسكۈنىلەرلىك ئائىلە باشقۇرۇشىنى بەرپا قىلىش",
    "device_operation": "ئەقلىي ئىقتىدارلىق ئۈسكۈنىلەرنى ئىشلىتىپ مەشغۇلات قىلغاندا، تېز سۈرئەتتە ئۆي ئورنىنى بېكىتىش قاتارلىق قولايلىق تەسىرات بىلەن تەمىنلەيدۇ",
    "show_home_info": "ئائىلە ئۇچۇرىنى كۆرسىتىش،ئائىلە باشقۇرۇش،ئۈسكۈنىنى ھەمبەھرىلىگەندە",
    "version_update": "ئەپ ۋە مۇقىم دىتال نەشىر دەرىجىسىنى ئۆستۈرۈش",
    "firmware_upgrade": "ئەقلىي ئۈسكۈنىنىڭ مۇقىم دىتال نەشىر دەرىجىسىنى ئۆستۈرۈشنى تەمىنلەش ئىقتىدارىغا ئىشلىتىلىدۇ.",
    "smart_device_connection": "ئەقلىي ئۈسكۈنە ئارقىلق ئۇلىنىش",
    "wifi_connection": "WLANياكى كۆكچىش ئارقىلىق ئەقلىي ئۈسكۈنىگە ئۇلانغاندا",
    "wifi_zigbee_connection": "WLAN،Zig-beeئۇسۇلى ئارقىلىق ئەقلىي ئۈسكۈنىلەرگە ئۇلىغاندا",
    "bluetooth_connection": "كۆكچىش ئارقىلىق ئەقلىي ئۈسكۈنىگە ئۇلانغاندا",
    "user_face_info": "ئابونىتنىڭ چىراي ئۇچۇرى",
    "face_info": "چىراي ئۇچۇرى",
    "face_recgonation": "چىراي تونۇشنى باشقۇرۇش ئىقتىدارى",
    "turn_on_face": "ئابونىت چىراي تونۇش ئىقتىدارىنى ئاچقاندا"
  }
}